import moment from "moment-timezone";
import { average, formatNumber, sum } from "utils";
import { EmptyNumberPlaceholder, TABLE_FORMAT_FULL } from "Consts";
import { isNullOrUndefined } from "@nevware21/ts-utils";

export const getAutoChartInterval = (data: any[]) => {
  if (!Array.isArray(data)) {
    return null;
  }

  if (data?.length > 1) {
    const deltaMs = data[1].x - data[0].x;
    let res = "";
    switch (deltaMs) {
      case 60000:
        res = "(1m)";
        break;
      case 300000:
        res = "(5m)";
        break;
      case 900000:
        res = "(15m)";
        break;
      case 1200000:
        res = "(20m)";
        break;
      case 3600000:
        res = "(1h)";
        break;
      case 10800000:
        res = "(3h)";
        break;
      case 21600000:
        res = "(6h)";
        break;
      case 43200000:
        res = "(12h)";
        break;
      case 86400000:
        res = "(1d)";
        break;
      case 604800000:
        res = "(7d)";
        break;
      default:
        res = "";
    }
    return res;
  }
};

export const formatChartDate = (date, format = TABLE_FORMAT_FULL) => {
  return moment(date).format(format);
};

export const getAggregation = (type, data, field = null, formatted = true) => {
  if (!data) return;
  const aggregatedY = data?.map((p) => (field ? +p[field] : +p.y));
  if (type === "Sum") return formatted ? formatNumber(sum(aggregatedY), 0) : sum(aggregatedY);
  if (type === "Max")
    return formatted ? formatNumber(Math.max(...aggregatedY), 0) : Math.max(...aggregatedY);
  if (type === "Min")
    return formatted ? formatNumber(Math.min(...aggregatedY), 0) : Math.min(...aggregatedY);
  if (type === "Avg") {
    return formatted
      ? formatNumber(average(aggregatedY), 0, true, EmptyNumberPlaceholder)
      : average(aggregatedY);
  }
};

export const scaleDataset = (dataset, field) => {
  const minVal = Math.min(...dataset.map((i) => +i[field]));
  const maxVal = Math.max(...dataset.map((i) => +i[field]));
  const scaleFactor = 100 / (maxVal - minVal);

  return dataset.map((i) => ({
    ...i,
    [field]: isNullOrUndefined(i[field]) ? null : ((+i[field] - minVal) * scaleFactor).toFixed(4),
    scale: +scaleFactor,
  }));
};

export const msToMinutes = (ms: number): number => {
  return ms / 1000 / 60;
};
